import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';

import { NS } from '@/constants';

import Icon from '@/components/common/iconedLinks/Icon';

import styles from './ImageLink.module.scss';
import { URLS } from '@/constants/urls';

type ImageLinkProps = {
  title: string;
  description?: string;
  image: string;
  imageWebp?: string;
  url?: string;
  onClick?: () => void;
  lazy?: boolean;
  alt: string;
}

const ImageLink = ({
  title,
  description,
  image,
  imageWebp,
  url,
  onClick,
  lazy = false,
  alt
}: ImageLinkProps): React.JSX.Element => {
  const router = useRouter();
  const { t } = useTranslation();

  const handleOnClick = () => {
    if (url) {
      router.push(url);
    } else if (onClick) {
      onClick();
    }
  };

  return (
    <div
      data-test-id="container"
      className={styles.container}
      onClick={() => handleOnClick()}
    >
      {imageWebp ? (
        <picture>
          <source srcSet={imageWebp} type="image/webp" />
          <img
            src={image}
            className={styles.img}
            alt={alt}
            loading={lazy ? 'lazy' : null}
          />
        </picture>
      ) : (
        <img
          src={image}
          className={styles.img}
          alt={alt}
          loading={lazy ? 'lazy' : null}
        />
      )}
      <div className={styles.content}>
        <div className={styles.text}>
          <span data-test-id="title" className={styles.title}>{title}</span>
          {description && <span data-test-id="desc" className={styles.description}>{description}</span>}
        </div>
        <Icon
          src={URLS.ANGLE_RIGHT_WHITE}
          alt={t('angleRightIcon', { ns: NS.ALTER })}
          width={24}
          height={24}
          lazy={lazy}
        />
      </div>
    </div>
  );
};

export default ImageLink;
